export default __webpack_public_path__ + "static/media/Aarush_dp.f01816bf.jpg";